import axiosInstance from 'custom-axios';
import { numberFormat, numberPerCentageFormat } from 'hooks/useNumberFormat';
import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { toast } from 'react-toastify';
import RadialBarChart from 'views/charts/RadialBarChart';
import { colorArray } from 'store/constant';
import DonutChart from 'views/charts/DonutChart';

const fundData = [
    {
        category: "Equity Fund",
        items: [
            { name: "Canadian Small Cap", value: "7.49%" },
            { name: "US Small Cap", value: "9.58%" },
            { name: "International Equity", value: "0.70%" },
            { name: "International Equity", value: "5.17%" },
            { name: "Emerging Market Equity", value: "7.86%" },
            { name: "US Large Cap", value: "0.88%" },
            { name: "US Large Cap", value: "8.06%" },
            { name: "Canadian Large Cap", value: "11.15%" },
            { name: "US/CAN Mid Cap", value: "5.94%" }
        ]
    },
    {
        category: "Fixed Income Fund",
        items: [
            { name: "CASH", value: "2.85%" },
            { name: "Short Term Bonds", value: "5.61%" },
            { name: "Corporate and Government Bonds", value: "19.68%" },
            { name: "Corporate Bonds", value: "12.04%" },
            { name: "Long Term Bonds", value: "0.98%" },
            { name: "Preferred Shares", value: "2.02%" }
        ]
    }
];



const AssetAllocation = (props) => {
    const userId = localStorage.getItem('user_id');
    var sizeOfGraphSection = props.size;
    const [totalProfitTotal, setTotalProfitTotal] = useState();
    const [chartAccountValue, setChartAccountValue] = useState([]);
    const [chartTitleName, setChartTitleName] = useState([]);

    const [totalAssetTotal, setTotalAssetTotal] = useState();

    // const [chartAssetValue, setChartAssetValue] = useState([]);
    // const [chartAssetTitle, setAssetChartTitle] = useState([]);

    const [assetClassChartData, setAssetClassChartData] = useState({
        assetValues: [],
        assetTitles: [],
        assetFundData: []
    });


    const [totalSymbolTotal, setTotalSymbolTotal] = useState();
    const [chartSymbolValue, setChartSymbolValue] = useState([]);
    const [chartSymbolTitle, setSymbolChartTitle] = useState([]);
    const [dataLength, setDataLength] = useState([]);


    const fetchAccountChartValues = async () => {
        try {
            var accountTitleName = [];
            var accountValue = [];
            const response = await axiosInstance.get(`api/getAccountChartValues/${userId}/account_chart_values`);
            // setChartFullData(response.data)

            setDataLength(response.data.accounts.length);
            setTotalProfitTotal(response.data.total_profit);

            for (let i = 0; i < response.data.accounts.length; i++) {
                accountTitleName.push(response.data.accounts[i].account);
                accountValue.push(response.data.accounts[i].accountPercentage);
            }

            setChartTitleName(accountTitleName);
            setChartAccountValue(accountValue);
        } catch (error) {
            toast.error(error.message);
        }
    };

    const getAccountChart = async () => {
        // try {
        //     const response = await axiosInstance.get(`api/getAssetChartValue/${userId}/asset_chart_value`);
        //     // console.log(response)
        // } catch (error) {
        //     toast.error(error.message)
        // }
    };
    const getAccountTypeChart = async () => { };

    const getAssetClassesChart = async () => {

        try {
            const assetTitles = [];
            const assetValues = [];

            const response = await axiosInstance.get(`api/getAssetChartValue/${userId}/asset_chart_value`);

            console.log(response)

            setTotalAssetTotal(response.data.assetData.totalProfitAssetTotal);

            response.data.assetData.assets.forEach(asset => {
                const percentage = ((asset.valuePercentage / response.data.assetData.totalProfitAssetTotal) * 100).toFixed(2);
                assetTitles.push(asset.asset);
                assetValues.push(Number(asset.valuePercentage)); // Use percentage values
            });

            setAssetClassChartData({
                assetValues,
                assetTitles,
                assetFundData: response.data.assetData.fundAllocation
            });

        } catch (error) {
            toast.error(error.message);
        }
    };
    const getSecuritiesChart = async () => {
        try {
            var accountTitleName = [];
            var accountValue = [];

            const response = await axiosInstance.get(`api/getSymbolChartValue/${userId}/symbol_chart_value`);

            setTotalSymbolTotal(response.data.symbolData.totalprofitSymbolTotal);

            for (let i = 0; i < response.data.symbolData.symbols.length; i++) {
                accountTitleName.push(response.data.symbolData.symbols[i].symbol);
                accountValue.push(Number(response.data.symbolData.symbols[i].valuePercentage));
            }

            setSymbolChartTitle(accountTitleName);
            setChartSymbolValue(accountValue);
        } catch (error) {
            toast.error(error.message);
        }
    };

    const AssetClassDonutChart = (props) => {
        return (
            <>
                <ReactApexChart
                    type="donut"
                    // width={450}
                    height={350}
                    series={props.seriesValue}
                    options={{
                        legend: {
                            show: true,
                            position: 'bottom'
                        },
                        // show in donut graph
                        // dataLabels: {
                        //     enabled: false
                        // },
                        tooltip: {
                            y: {
                                formatter: function (value) {
                                    //  return numberFormat(value);
                                    return numberFormat(value);
                                }
                            }
                        },
                        // noData: { text: 'Loading graph...' },
                        noData: { text: 'Graph Data not found.' },
                        // colors: ['#41a3b0', '#4c5c71'],
                        colors: colorArray,

                        plotOptions: {
                            pie: {
                                startAngle: 0,
                                endAngle: 360,
                                expandOnClick: true,
                                offsetX: 0,
                                offsetY: 0,
                                customScale: 1,
                                dataLabels: {
                                    offset: 0,
                                    minAngleToShowLabel: 10
                                },
                                donut: {
                                    size: '70%', // change the thickness og graph
                                    background: 'transparent',
                                    labels: {
                                        show: true,
                                        name: {
                                            show: true,
                                            fontSize: '15px',
                                            fontFamily: 'Helvetica, Arial, sans-serif',
                                            fontWeight: 600,
                                            color: '#454B1B',
                                            offsetY: -10,
                                            formatter: function (val) {
                                                return val;
                                            }
                                        },
                                        value: {
                                            show: true,
                                            fontSize: '15px',
                                            fontFamily: 'Helvetica, Arial, sans-serif',
                                            fontWeight: 400,
                                            // color: "#FF0000",
                                            color: undefined,
                                            offsetY: 16,
                                            formatter: function (val) {
                                                return numberFormat(val);
                                            }
                                        },
                                        total: {
                                            show: true,
                                            showAlways: true, // if it is true then total in the middle always show.
                                            // label: 'Total',
                                            label: props.centerTitle ? props.centerTitle : 'Total',
                                            fontSize: '17px',
                                            fontFamily: 'Helvetica, Arial, sans-serif',
                                            fontWeight: 500,
                                            color: '#373d3f',
                                            formatter: function () {
                                                return props.total > 0 ? numberFormat(props.total) : '';
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        labels: props.labelTitle
                    }}
                />
            </>
        )
    }


    useEffect(() => {
        fetchAccountChartValues(); // for assetallocation
    }, []);

    return (
        <>
            <div className={`${sizeOfGraphSection === 'full' ? 'col-lg-12' : 'col-lg-6'} col-md-12 mb-4`}>
                <div className={`card ${!sizeOfGraphSection === 'full' ? 'asset-allocation-graph' : ' '}`} style={{ minHeight: sizeOfGraphSection === 'half' ? '520px' : '' }}>
                    <div className="card-header d-xxl-flex justify-content-between">
                        <h6 className="card-title">Assent Allocation</h6>
                    </div>
                    {dataLength > 0 ? (
                        <>
                            <div className="account-tab mt-4">
                                <nav>
                                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                        <button
                                            onClick={() => getAccountChart()}
                                            className="nav-link active"
                                            id="account-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#account"
                                            type="button"
                                            role="tab"
                                            aria-controls="nav-home"
                                            aria-selected="true"
                                        >
                                            Account
                                        </button>
                                        {/* <button
                                            onClick={() => getAccountTypeChart()}
                                            className="nav-link"
                                            id="account-type-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#account-type"
                                            type="button"
                                            role="tab"
                                            aria-controls="account-type"
                                            aria-selected="false"
                                        >
                                            Account Type
                                        </button> */}
                                        <button
                                            onClick={() => getAssetClassesChart()}
                                            className="nav-link"
                                            id="account-classic-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#account-classic"
                                            type="button"
                                            role="tab"
                                            aria-controls="account-classic"
                                            aria-selected="false"
                                        >
                                            Asset Class
                                        </button>
                                        <button
                                            onClick={() => getSecuritiesChart()}
                                            className="nav-link"
                                            id="nav-security-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#nav-security"
                                            type="button"
                                            role="tab"
                                            aria-controls="nav-security"
                                            aria-selected="false"
                                        >
                                            Security
                                        </button>
                                    </div>
                                </nav>
                            </div>

                            <div className="card-body card-body-height">
                                <div className="tab-content" id="nav-tabContent">
                                    <div className="tab-pane fade show active" id="account" role="tabpanel" aria-labelledby="account-tab">
                                        <div className="row align-item-center">
                                            <div className="col-lg-12">
                                                <RadialBarChart
                                                    height={400}
                                                    series={chartAccountValue}
                                                    total={totalProfitTotal}
                                                    titleName={chartTitleName}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/*===========================ACCOUNT TYPE CHART===========================*/}
                                    {/* <div className="tab-pane fade" id="account-type" role="tabpanel" aria-labelledby="account-type-tab">
                                        <RadialBarChart
                                            height={450}
                                            series={chartAccountValue}
                                            total={totalProfitTotal}
                                            titleName={chartTitleName}
                                        />
                                    </div> */}

                                    {/* =================== ASSET CLASS CHART (ONLY THIS SHOWS FUND LIST) =================== */}


                                    <div className="tab-pane fade" id="account-classic" role="tabpanel" aria-labelledby="account-classic-tab">
                                        {/* d-flex flex-row */}
                                        <div className="row align-item-center">
                                            <div className='d-flex flex-row'>
                                                <div className="col-md-5 d-flex flex-column">
                                                    <div className="card shadow-sm">
                                                        <div className="card-body">
                                                            {assetClassChartData?.assetFundData?.map((fund, index) => (
                                                                <div key={index} className="mb-3">
                                                                    <h5 className="fw-bold text-primary">{fund.category}</h5>
                                                                    <ul className="list-group">
                                                                        {fund.items.map((item, idx) => (
                                                                            <li key={idx} className="list-group-item d-flex justify-content-between">
                                                                                {item.name}
                                                                                <span className="fw-semibold">{numberPerCentageFormat(item.value)}%</span>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-7">
                                                    {/* <div className="card shadow-sm"> */}
                                                    <div className="card-body">
                                                        <AssetClassDonutChart
                                                            seriesValue={assetClassChartData.assetValues}
                                                            labelTitle={assetClassChartData.assetTitles}
                                                            total={totalProfitTotal}
                                                            dataFormat="percentage"
                                                        />
                                                    </div>
                                                    {/* </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    {/* <div
                                        className="tab-pane fade"
                                        id="account-classic"
                                        role="tabpanel"
                                        aria-labelledby="account-classic-tab"
                                    >

                                        <DonutChart seriesValue={assetClassChartData.assetValues} labelTitle={assetClassChartData.assetTitles} total={totalProfitTotal} dataFormat="percentage" />
                                    </div> */}



                                    {/*=====================ASSET SECURITY CHART====================*/}
                                    <div className="tab-pane fade" id="nav-security" role="tabpanel" aria-labelledby="nav-security-tab">
                                        <DonutChart seriesValue={chartSymbolValue} labelTitle={chartSymbolTitle} total={totalProfitTotal} dataFormat="percentage" />
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (

                        <div className="text-center padding10px"> No Records Found</div>

                    )}
                </div>
            </div>
        </>
    );
};

export default AssetAllocation;
